// src/components/batches_temp.js
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getBatchesTemp, deleteBatchTemp, finalizeBatchTemp } from "../api";

const BatchTempList1 = ({ id_c }) => {
    const { t } = useContext(LanguageContext);
    const [data, setData] = useState(null);

    const [filterBatch, setFilterBatch] = useState("");
    const [filterMachine, setFilterMachine] = useState("");
    const [filterProduct, setFilterProduct] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const res = await getBatchesTemp(id_c);
            setData(res);
        };
        if (id_c) fetchData();
    }, [id_c]);

    if (!data) return <p>{t("MList1")}</p>;

    const fb = filterBatch.trim().toLowerCase();
    const fm = filterMachine.trim().toLowerCase();
    const fp = filterProduct.trim().toLowerCase();

    const rows = (data?.batches || []).filter(b => {
        const bId = (b.id_batch || "").toString().toLowerCase();
        const mq = (b.cod_maq || "").toLowerCase();
        const pr = (b.id_prod || "").toString().toLowerCase();
        return bId.startsWith(fb) && mq.startsWith(fm) && pr.startsWith(fp);
    });

    return (
        <div className="box1">
            <div className="box9">
                <button className="button7" onClick={() => navigate("/new_batch_temp")}>
                    {t("batchList11")} {/* "Nuevo" */}
                </button>

                <div className="table5">
                    <input type="text" placeholder="🔎 Filtrar por lote"
                        value={filterBatch} onChange={e => setFilterBatch(e.target.value)}
                        style={{ width: "30%", float: "left" }} />
                    <input type="text" placeholder="🔎 Filtrar por máquina"
                        value={filterMachine} onChange={e => setFilterMachine(e.target.value)}
                        style={{ width: "30%", float: "left" }} />
                    <input type="text" placeholder="🔎 Filtrar por producto"
                        value={filterProduct} onChange={e => setFilterProduct(e.target.value)}
                        style={{ width: "30%", float: "left" }} />
                </div>

                <table className="table5">
                    <thead>
                        <tr>
                            <th>{t("batchList7")}</th>
                            <th>{t("batchList8")}</th>
                            <th>{t("batchList10")}</th>
                            <th>{t("operator1")}</th>
                            <th>{t("batchList12")}</th>
                            <th>{t("batchList2")}</th>
                            <th>{t("batchList3")}</th>


                            <th colSpan={3}>{t("actType6")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((b) => (
                            <tr key={`${b.id}-${b.id_batch}-${b.id_prod}`}>
                                <td>{(b.date_begin || "").slice(0, 10)}</td>
                                <td>{b.time_begin?.slice(0, 5)}</td>
                                <td>{b.time_end ? b.time_end.slice(0, 5) : "-"}</td>
                                <td>{b.id_operator}</td>
                                <td>{b.id_batch}</td>
                                <td>{b.cod_maq}</td>
                                <td>{b.id_prod}</td>


                                <td>
                                    <button className="button" onClick={() => navigate(`/edit_batch_temp/${b.id}`)}>
                                        {t("MList7")}
                                    </button>
                                </td>
                                <td>
                                    <button className="buttonDel" onClick={async () => {
                                        if (!window.confirm("¿Eliminar este parcial?")) return;
                                        await deleteBatchTemp(id_c, b.id);
                                        const res = await getBatchesTemp(id_c);
                                        setData(res);
                                    }}>
                                        {t("general1")}
                                    </button>
                                </td>
                                <td>
                                    <button className="button" onClick={async () => {
                                        try {
                                            await finalizeBatchTemp(id_c, b.id);
                                            const res = await getBatchesTemp(id_c);
                                            setData(res);
                                            alert("✅ Finalizado y movido a consolidado");
                                        } catch (e) {
                                            alert(e?.response?.data?.message || "No se pudo finalizar (faltan campos)");
                                        }
                                    }}>
                                        Finalizar ➜
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default BatchTempList1;
